import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import 'dayjs/locale/nl';
import 'dayjs/locale/pt-br';
import { Observable, forkJoin, map } from 'rxjs';

export class LazyTranslateLoader extends TranslateHttpLoader {
  private httpClient;

  constructor(http: HttpClient, prefix?: string, suffix?: string) {
    super(http, prefix, suffix);
    this.httpClient = http;
  }

  public getTranslation(lang: string): Observable<any> {
    return forkJoin(
      this.httpClient.get('assets/i18n' + '/' + lang + '.json'),
      this.httpClient.get('assets/i18n' + '/' + lang + '-primeng.json'),
    ).pipe(
      map(([lang, prime]) => {
        return {
          ...lang,
          primeng: prime,
        };
      }),
    );
  }
}

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new LazyTranslateLoader(http);
}

export function initializeTranslations(): () => Promise<void> {
  return async (): Promise<void> => {
    return new Promise(() => {});
  };
}
